export default `
# Get in touch

---

## Email
Have a question about gndrv? Send an email to **isaac@gndrv.com**

## GitHub
You can contribute to gndrv or just poke around the source code for the CLI at our [GitHub Repository](https://github.com/gndrv/gndrv)

`;



// WEBPACK FOOTER //
// ./src/markdown/Contact.md.js